import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import routes from "routes.js";
import { Layout, Row, Col } from "antd";
import Footer from "../components/Footer/footer";
import './Tutor.scss';
import NavbarLogin from "../components/Header/Navbars/NavbarLogin";
import NavbarBack from "../components/Header/Navbars/NavbarBack";
import {useSelector, useDispatch} from "react-redux";
import {authActions} from "../_actions";

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      if (prop.layout === "/tutorAuth") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      }
      return null;
    })}
  </Switch>
);

export default function TutorAuth({ ...rest }) {
  const dispatch = useDispatch();
    var userLogin = useSelector((state) => state.authReducer.user);
    var actualYear = useSelector((state) => state.authReducer.actualYear);
  
    useEffect(()=>{
        if (!actualYear){
          dispatch(authActions.actualYear())
  
        }
    },[])
  return (
    <>
        {(!rest.location.pathname.includes("register")) &&
          <div className={"defaultBack admin-layout"}>
              {/*userLogin&&<NavbarLoginTutor className="menuNavAdmin"/>*/}
              {(rest.location.pathname.includes("students")) &&
                <NavbarLogin className="menuNavAdmin"/>
              }
              {(rest.location.pathname.includes("students")) &&
                <NavbarBack current={rest.location.pathname}/>
              }
              {switchRoutes}
              {(rest.location.pathname.includes("students")) &&
                <Footer className="footer-admin"/>
              }
          </div>
        }
        {(rest.location.pathname.includes("register")) &&
          <Layout className="authContainer fullHeightLayout">
              {/* <Row justify="space-around" align="middle"  style={{minHeight:"100vh"}}> */}
              <Row justify="space-around" align="middle"  className="fullHeightBody">
                  <Col span={24}>{switchRoutes}</Col>
              </Row>
              <Footer />
          </Layout>
        }
    </>
  );
}
